import Head from 'next/head';

import { COOKIES } from '@sravni/mpl-antifraud/lib/constants/cookies';

import { minifyString } from '../../utils/minifyString';

export const AntiFraudReadCookies = () => (
  <Head>
    <script
      dangerouslySetInnerHTML={{
        __html: minifyString(`
          function readCookiesForAf() {
            window.__AF__ = {
              gclientID: '',
              yclientID: ''
            };

            var gaMatch = document.cookie.match(/${COOKIES.GA}=([^;]+)/);
            if (gaMatch) {
              var gclientID = gaMatch[1];
              if (!gclientID && window.ga !== undefined) {
                var trackers = window.ga.getAll();
                if (trackers.length > 0) {
                    gclientID = trackers[0].get('clientId');
                }
              }
              window.__AF__.gclientID = gclientID.split('.').splice(-2).join('.');
            }

            var yaMatch = document.cookie.match(/${COOKIES.YM_UID}=([^;]+)/);
            if (yaMatch) {
              window.__AF__.yclientID = yaMatch[1];
            }

          }
          readCookiesForAf();
        `),
      }}
    />
  </Head>
);
